import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { makeReportFilterSchema } from "./base-report-filter";
import { ReportFilterType } from "./report-filter-type";

export enum ReturnTypeFilterQuery {
  IS_ANY = "isAny",
  IS_NONE = "isNone",
}

const ReturnTypeFilterSchema_ = makeReportFilterSchema(
  ReportFilterType.RETURN_TYPE,
  ReturnTypeFilterQuery,
  z.array(createEnum(ReturnTypeEnum)),
);
export const ReturnTypeFilterSchema: z.ZodType<ReturnTypeFilter> =
  ReturnTypeFilterSchema_;
export interface ReturnTypeFilter
  extends z.infer<typeof ReturnTypeFilterSchema_> {}
